import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-add-serving-time-modal',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    ReactiveFormsModule,
    MatIcon,
    CommonModule,
  ],
  templateUrl: './add-serving-time-modal.component.html',
  styleUrl: './add-serving-time-modal.component.css',
})
export class AddServingTimeModalComponent {
  readonly dialogRef = inject(MatDialogRef<AddServingTimeModalComponent>);
  readonly data = inject<any>(MAT_DIALOG_DATA);

  servingTimeForm: FormGroup;

  constructor(private fb: FormBuilder) {
    if (this.data.servingTime) {
      this.servingTimeForm = this.fb.group(
        {
          name: [
            this.data.servingTime.name,
            [
              Validators.required,
              Validators.minLength(3),
              Validators.maxLength(20),
              this.uniqueNameValidator(),
            ],
          ],
          start_time: [this.data.servingTime.start_time, [Validators.required]],
          end_time: [this.data.servingTime.end_time, [Validators.required]],
        },
        { validators: this.timeRangeValidator.bind(this) },
      );
    } else {
      this.servingTimeForm = this.fb.group(
        {
          name: [
            '',
            [
              Validators.required,
              Validators.minLength(3),
              Validators.maxLength(20),
              this.uniqueNameValidator(),
            ],
          ],
          start_time: ['', [Validators.required]],
          end_time: ['', [Validators.required]],
        },
        { validators: this.timeRangeValidator.bind(this) },
      );
    }
  }

  ngOnInit(): void {}

  addServingTime() {
    this.dialogRef.close({
      name: this.servingTimeForm.get('name')?.value,
      start_time: this.servingTimeForm.get('start_time')?.value,
      end_time: this.servingTimeForm.get('end_time')?.value,
    });
  }

  timeRangeValidator(group: AbstractControl): { [key: string]: boolean } | null {
    const startTime = group.get('start_time')?.value;
    const endTime = group.get('end_time')?.value;

    if (startTime && endTime) {
      const start = this.convertToMinutes(startTime);
      const end = this.convertToMinutes(endTime);

      if (start >= end) {
        return { timeRangeInvalid: true };
      }
    }
    return null;
  }

  convertToMinutes(time: any) {
    let splitString = time.split(':');
    return Number(splitString[0]) * 60 + splitString[1];
  }

  uniqueNameValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value?.trim();
      if (!value) {
        return null;
      }
      const isDuplicate = this.data?.allServingTimes?.find(
        (f: any) => f.name == value && f.name != this.data.servingTime?.name,
      );
      return isDuplicate ? { uniqueName: true } : null;
    };
  }
}
